<div class="flex flex-col gap-4" data-cy="medical-quarantine">
  <h3 class="medical-section-title text-lg font-semibold m-0">{{ 'animalMedical.sections.quarantine' | transloco }}</h3>

  @if (!active.length && !planned.length && !finished.length) {
    <p-message severity="info">{{ 'animalMedical.quarantine.empty' | transloco }}</p-message>
  }

  @for (quarantine of active; track quarantine.id) {
    <article class="border border-orange-300 bg-orange-50 rounded-lg p-3 flex flex-col gap-2">
      <div class="flex flex-wrap items-center gap-2">
        <p-tag severity="warn" [value]="'animalMedical.quarantine.active' | transloco" />
        <span class="font-semibold">{{ reasonLabelKey(quarantine.reason) | transloco }}</span>
        @if (quarantine.blocksAdoption) {
          <p-tag severity="danger" icon="pi pi-lock" [value]="'animalMedical.quarantine.adoptionBlocked' | transloco" />
        }
      </div>
      <div class="grid grid-cols-2 md:grid-cols-4 gap-2 text-sm">
        <div>
          <div class="text-xs text-gray-500">{{ 'animalMedical.fields.startsAt' | transloco }}</div>
          {{ quarantine.startsAt | date:'dd.MM.yyyy' }}
        </div>
        <div>
          <div class="text-xs text-gray-500">{{ 'animalMedical.fields.endsAt' | transloco }}</div>
          {{ quarantine.endsAt ? (quarantine.endsAt | date:'dd.MM.yyyy') : ('animalMedical.untilFurtherNotice' | transloco) }}
        </div>
        <div>
          <div class="text-xs text-gray-500">{{ 'animalMedical.fields.authority' | transloco }}</div>
          {{ authorityName(quarantine) }}
        </div>
        <div>
          <div class="text-xs text-gray-500">{{ 'animalMedical.quarantine.createdBy' | transloco }}</div>
          {{ creatorName(quarantine) }}
          @if (quarantine.createdAt) { · {{ quarantine.createdAt | date:'dd.MM.yyyy' }} }
        </div>
      </div>
      @if (progress(quarantine) !== null) {
        <div class="flex items-center gap-3">
          <p-progressbar class="flex-1" [value]="progress(quarantine)!" [showValue]="false" />
          <span class="text-xs text-gray-600 whitespace-nowrap">
            {{ 'animalMedical.quarantine.remaining' | transloco: { days: remainingDays(quarantine) } }}
          </span>
        </div>
      } @else {
        <span class="text-sm text-gray-600">{{ 'animalMedical.untilFurtherNotice' | transloco }}</span>
      }
      @if (quarantine.notes) {
        <span class="text-sm whitespace-pre-line">{{ quarantine.notes }}</span>
      }
    </article>
  }

  @if (planned.length) {
    <div class="flex flex-col gap-2">
      <h4 class="medical-dialog-heading">{{ 'animalMedical.quarantine.plannedHeadline' | transloco }}</h4>
      @for (quarantine of planned; track quarantine.id) {
        <div class="border border-gray-200 rounded-lg p-3 flex flex-wrap items-center gap-3 text-sm">
          <p-tag severity="info" [value]="'animalMedical.quarantine.planned' | transloco" />
          <span class="font-semibold">{{ reasonLabelKey(quarantine.reason) | transloco }}</span>
          <span>
            {{ quarantine.startsAt | date:'dd.MM.yyyy' }} –
            {{ quarantine.endsAt ? (quarantine.endsAt | date:'dd.MM.yyyy') : ('animalMedical.untilFurtherNotice' | transloco) }}
          </span>
          @if (quarantine.blocksAdoption) {
            <p-tag severity="secondary" icon="pi pi-lock" [value]="'animalMedical.quarantine.adoptionBlocked' | transloco" />
          }
          <span class="text-gray-500">{{ authorityName(quarantine) }}</span>
        </div>
      }
    </div>
  }

  @if (finished.length) {
    <div class="flex flex-col gap-2">
      <h4 class="medical-dialog-heading">{{ 'animalMedical.quarantine.finishedHeadline' | transloco }}</h4>
      <p-table [value]="finished" dataKey="id" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'animalMedical.fields.reason' | transloco }}</th>
            <th>{{ 'animalMedical.fields.startsAt' | transloco }}</th>
            <th>{{ 'animalMedical.fields.endsAt' | transloco }}</th>
            <th>{{ 'animalMedical.quarantine.adoption' | transloco }}</th>
            <th>{{ 'animalMedical.fields.authority' | transloco }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-quarantine>
          <tr>
            <td>{{ reasonLabelKey(quarantine.reason) | transloco }}</td>
            <td>{{ quarantine.startsAt | date:'dd.MM.yyyy' }}</td>
            <td>{{ quarantine.endsAt | date:'dd.MM.yyyy' }}</td>
            <td>{{ (quarantine.blocksAdoption ? 'animalMedical.quarantine.blocked' : 'animalMedical.quarantine.notBlocked') | transloco }}</td>
            <td>{{ authorityName(quarantine) }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</div>
